import React from "react";

const Spinner: React.FunctionComponent = () => {
    return <img src="../images/spinner.gif" className="center" />
}

export default Spinner;